/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnStationTokenType } from './en-station-token-type';
 /**
 *
 *
 * @export
 * @interface StationTokenDto
 */
export interface StationTokenDto {

    /**
     * @type {string}
     * @memberof StationTokenDto
     */
    token: string;

    /**
     * @type {EnStationTokenType}
     * @memberof StationTokenDto
     */
    type: EnStationTokenType;

    /**
     * @type {string}
     * @memberof StationTokenDto
     */
    expiresAt: string;
}
